<template>
   <div class="max-w-screen-mobile mx-auto h-screen py-2">
     <SelfieMobileGallery />
   </div>
</template>

<script>
import SelfieMobileGallery from "@/components/mobile/SelfieMobileGallery.vue"

export default {
  name: 'SelfieGallery',
  components: {
    SelfieMobileGallery
  },
  mounted() {
    this.$i18n.locale = this.lang;
  },
  data() {
    return {
      lang: localStorage.getItem('language') ? localStorage.getItem('language') : 'ro',
    }
  }
}
</script>
